import { MenuItemProps, MenuItem as MuiMenuItem } from "@mui/material";

type Props = MenuItemProps;

export const MenuItem = ({ children, ...props }: Props) => {
  return <MuiMenuItem {...props}>{children}</MuiMenuItem>;
};
